import type { BariPreReferralData } from '@common/validation/customControls/bariPre/bariPreReferral/v1/bariPreReferralSchemaV1';

export const initialData: BariPreReferralData = {
    assets: [],
    generalPractitioner: {
        organizationId: null,
        practitionerId: null,
    },
    medisch_dossier_nummer: null,
    patient: {
        emailAddress: null,
        homePhoneNumber: null,
        mobileNumber: null,
    },
    toelichting: null,
    toestemming_van_patient: false,
};
